import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Link from 'react-router-dom/Link';
import {sendEmail} from '../actions';
import LoadingSpinner from '../../Layout/components/LoadingSpinner';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../translations/translations_contact';

class ContactForm extends Component {
    state = {
        errors: {},
        openSnackbarErrorSent: false,
        title: '',
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        address_line1: '',
        address_line2: '',
        address_postal_code: '',
        address_city: '',
        message: '',
        emailSent: false,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidUpdate(prevProps, prevState) {
        const {emailSent, emailSending} = this.props.contact;

        if (prevProps.errors !== this.props.errors) {
            this.setState({
                errors: this.props.errors,
                openSnackbarErrorSent: false,
            });

            const errorsData = (this.props.errors.hasOwnProperty('data')) ? this.props.errors.data : {};
            if (errorsData.status && errorsData.status === 406) {
                this.setState({
                    openSnackbarErrorSent: true
                });
            }
        }

        if (!emailSending && prevProps.contact.emailSent !== emailSent) {
            this.setState({
                emailSent: true,
            });
        }
    }

    handleChange = name => e => {
        this.setState({
            [name]: e.target.value,
        });
    };

    handleCloseSnackbarErrorSent = (e) => {
        this.setState({openSnackbarErrorSent: false});
    };

    handleSubmit = e => {
        e.preventDefault();

        const data = {
            title: this.state.title,
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            phone: this.state.phone,
            email: this.state.email,
            address_line1: this.state.address_line1,
            address_line2: this.state.address_line2,
            address_postal_code: this.state.address_postal_code,
            address_city: this.state.address_city,
            message: this.state.message,
            site: 1, // = AGEP
        };

        this.props.sendEmail(data);
    };

    render() {
        const {emailSending} = this.props.contact;
        const {errors, emailSent} = this.state;
        const errorsData = (errors.hasOwnProperty('data')) ? errors.data : {};

        if (emailSent) {
            return (
                <div className="row row-thanks">
                    <div className="col col-12 col-lg-9">
                        <h3><Translate id="contact.thanks_title" /></h3>
                        <Translate id="contact.thanks_message" />
                        <Button variant="contained" color="primary" className="btn" component={props => <Link to="/" {...props}/>}>
                            <Translate id="contact.button_thanks_back" />
                        </Button>
                    </div>
                </div>
            )
        }

        return (
            <Fragment>
                <form autoComplete="off" onSubmit={this.handleSubmit}>
                    <div className="row">
                        <div className="col col-12 col-lg-4">
                            <FormControl required className="formControl" margin="normal" fullWidth={true} error={errorsData.title ? true : false}>
                                <InputLabel htmlFor="you-are">
                                    <Translate id="contact.field_you_are" />
                                </InputLabel>
                                <Select
                                    value={this.state.title}
                                    onChange={this.handleChange('title')}
                                    inputProps={{
                                        name: 'title',
                                        id: 'you-are',
                                    }}
                                >
                                    <MenuItem value="mr"><Translate id="contact.field_you_are_mr" /></MenuItem>
                                    <MenuItem value="me"><Translate id="contact.field_you_are_me" /></MenuItem>
                                </Select>
                                {errorsData.title && (<FormHelperText className="form-helper">{this.props.translate('contact.' + errorsData.title)}</FormHelperText>)}
                            </FormControl>

                            <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.first_name ? true : false}>
                                <InputLabel htmlFor="first_name" className="form-label"><Translate id="contact.field_first_name" /> *</InputLabel>
                                <Input id="first_name" value={this.state.first_name} onChange={this.handleChange('first_name')} className="form-input" />
                                {errorsData.first_name && (<FormHelperText className="form-helper">{this.props.translate('contact.' + errorsData.first_name)}</FormHelperText>)}
                            </FormControl>

                            <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.last_name ? true : false}>
                                <InputLabel htmlFor="last_name" className="form-label"><Translate id="contact.field_last_name" /> *</InputLabel>
                                <Input id="last_name" value={this.state.last_name} onChange={this.handleChange('last_name')} className="form-input" />
                                {errorsData.last_name && (<FormHelperText className="form-helper">{this.props.translate('contact.' + errorsData.last_name)}</FormHelperText>)}
                            </FormControl>

                            <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.phone ? true : false}>
                                <InputLabel htmlFor="phone" className="form-label"><Translate id="contact.field_phone" /> *</InputLabel>
                                <Input id="phone" value={this.state.phone} onChange={this.handleChange('phone')} className="form-input" />
                                {errorsData.phone && (<FormHelperText className="form-helper">{this.props.translate('contact.' + errorsData.phone)}</FormHelperText>)}
                            </FormControl>

                            <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.email ? true : false}>
                                <InputLabel htmlFor="email" className="form-label"><Translate id="contact.field_email" /> *</InputLabel>
                                <Input id="email" value={this.state.email} onChange={this.handleChange('email')} className="form-input" type="email" />
                                {errorsData.email && (<FormHelperText className="form-helper">{this.props.translate('contact.' + errorsData.email)}</FormHelperText>)}
                            </FormControl>
                        </div>
                        <div className="col col-12 col-lg-4 offset-lg-1">
                            <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_line1 ? true : false}>
                                <InputLabel htmlFor="address_line1" className="form-label"><Translate id="contact.field_postal_address" /> *</InputLabel>
                                <Input id="address_line1" value={this.state.address_line1} onChange={this.handleChange('address_line1')} className="form-input" />
                                {errorsData.address_line1 && (<FormHelperText className="form-helper">{this.props.translate('contact.' + errorsData.address_line1)}</FormHelperText>)}
                            </FormControl>

                            <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_line2 ? true : false}>
                                <InputLabel htmlFor="address_line2" className="form-label"><Translate id="contact.field_postal_address2" /></InputLabel>
                                <Input id="address_line2" value={this.state.address_line2} onChange={this.handleChange('address_line2')} className="form-input" />
                                {errorsData.address_line2 && (<FormHelperText className="form-helper">{this.props.translate('contact.' + errorsData.address_line2)}</FormHelperText>)}
                            </FormControl>

                            <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_postal_code ? true : false}>
                                <InputLabel htmlFor="address_postal_code" className="form-label"><Translate id="contact.field_postal_code" /> *</InputLabel>
                                <Input id="address_postal_code" value={this.state.address_postal_code} onChange={this.handleChange('address_postal_code')} type="number" className="form-input" />
                                {errorsData.address_postal_code && (<FormHelperText className="form-helper">{this.props.translate('contact.' + errorsData.address_postal_code)}</FormHelperText>)}
                            </FormControl>

                            <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_city ? true : false}>
                                <InputLabel htmlFor="address_city" className="form-label"><Translate id="contact.field_city" /> *</InputLabel>
                                <Input id="address_city" value={this.state.address_city} onChange={this.handleChange('address_city')} className="form-input" />
                                {errorsData.address_city && (<FormHelperText className="form-helper">{this.props.translate('contact.' + errorsData.address_city)}</FormHelperText>)}
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-12 col-lg-9">
                            <FormControl className="form-control" fullWidth={true} margin="normal">
                                <TextField  id="message" value={this.state.message} onChange={this.handleChange('message')} className="form-input" multiline rows={4} rowsMax={8} placeholder="Message *" error={errorsData.message ? true : false} />
                                {errorsData.message && (<FormHelperText className="form-helper">{this.props.translate('contact.' + errorsData.message)}</FormHelperText>)}
                            </FormControl>
                        </div>
                    </div>
                    {emailSending ? (
                        <div className="row row-loading mt-50">
                            <div className="col-3 mx-auto">
                                <div className="text-center">
                                    <LoadingSpinner/>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row mt-30 mt-lg-50">
                            <div className="col col-12 col-lg-3">
                                <Typography variant="caption" className="mb-10">
                                    * <Translate id="contact.mandatory_fields" />
                                </Typography>
                            </div>
                            <div className="col col-12 col-lg-6">
                                <Button variant="contained" color="primary" size="large" className="btn-submit float-right" type="submit" style={{float: 'right'}}>
                                    <Translate id="contact.button_send" />
                                </Button>
                            </div>
                        </div>
                    )}
                </form>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    open={this.state.openSnackbarErrorSent}
                    autoHideDuration={6000}
                    onClose={this.handleCloseSnackbarErrorSent}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id"><Translate id="contact.error_sending" /></span>}
                    action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            onClick={this.handleCloseSnackbarErrorSent}
                        >
                            <CloseIcon />
                        </IconButton>,
                    ]}
                />
            </Fragment>
        );
    }
}

ContactForm.propTypes = {
    sendEmail: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    contact: state.contact,
    errors: state.errors,
});

export default connect(mapStateToProps, {sendEmail})(withLocalize(ContactForm));



// WEBPACK FOOTER //
// ./src/features/Contact/components/ContactForm.js